import { Component, Input, OnInit } from '@angular/core';
import { PropertiesSettings as ps } from "../../../../core/configuration/properties-settings";
import { SezioneEconomica } from "../../../models/sezioni/sezione-economica";
import { UtilityCommon } from "../../../utils/utility-common";

@Component({
  selector: 'app-valore-economico-view',
  templateUrl: './valore-economico-view.component.html',
  styleUrls: ['./valore-economico-view.component.css']
})
export class ValoreEconomicoViewComponent implements OnInit {
  idPetitumQuantificabile = ps.ID_TIPO_PETITUM_QUANTIFICABILE;
  @Input() recuperoCrediti: boolean;
  @Input() sezioneDatiEconomici: boolean;
  @Input() sezione: SezioneEconomica;
  calcolaSomma = UtilityCommon.calcolaSomma;
  constructor() { }

  ngOnInit() {
  }

}
